var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.imageSrc)?_c('img',{attrs:{"src":_vm.imageSrc}}):_c('span',[_vm._v(_vm._s(_vm.fio && _vm.fio[0]))])
}
var staticRenderFns = []

export { render, staticRenderFns }